<template>
  <div data-component-group="filter-forms" data-component="network">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="countries"
    >
      <v-autocomplete
        clearable
        ref="business"
        v-model="business"
        :items="businesses"
        :loading="isLoadingBusinesses"
        prepend-inner-icon="domain"
        :return-object="true"
        item-title="name"
        item-value="id"
        :label="$t('business_name')"
        v-model:search="businessSearch"
      />

      <v-autocomplete
        ref="network"
        clearable
        v-model="network"
        :items="networks"
        :loading="isLoadingNetworks"
        prepend-inner-icon="share"
        :return-object="true"
        item-title="name"
        :label="$t('network_name')"
        v-model:search="networkSearch"
      />

      <v-autocomplete
        ref="status"
        clearable
        v-model="status"
        :items="statuses"
        prepend-inner-icon="download_done"
        :return-object="true"
        item-title="name"
        :label="$t('status')"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import { v1 as uuidv1 } from 'uuid';
  import FiltersForm from './FiltersBase';
  import { isNonEmptyArr, isNum, isStr, debounce } from '../../../utils';

  const searchDebouncer = debounce({
    id: uuidv1(),
    timeout: 500
  });

  export default {
    components: {
      FiltersForm,
    },
    emits: ['filter', 'clearFilters'],
    data() {
      return {
        business: null,
        countries: [],
        network: null,
        status: null,
        networks: [],
        networkSearch: '',
        businessSearch: '',
        isLoadingNetworks: false,
        isLoadingBusinesses: false,
        isRefreshingNetworks: false,
        isRefreshingBusinesses: false,
      };
    },
    computed: {
      businesses() {
        return this.$store.getters['businesses/items'];
      },
      statuses() {
        return this.$store.getters['networks/statuses'];
      },
      hasFilters() {
        const { business = {}, countries = [], network = {}, status = {} } = this;

        return (
          isNum(business?.id) ||
          isNonEmptyArr(countries) ||
          isNum(network?.id) ||
          isNum(status?.id)
        );
      },
    },
    watch: {
      business() {
        this.isRefreshingBusinesses = true;
      },
      network() {
        this.isRefreshingNetworks = true;
      },
      businessSearch(nextSearch) {
        if (isStr(nextSearch)) {
          if (this.isRefreshingBusinesses) {
            this.isRefreshingBusinesses = false;
            return false;
          }

          searchDebouncer(() => this.getBusinesses(nextSearch));
        }
      },
      networkSearch(nextSearch) {
        if (isStr(nextSearch)) {
          if (this.isRefreshingNetworks) {
            this.isRefreshingNetworks = false;
            return false;
          }

          searchDebouncer(() => this.searchNetworks(nextSearch));
        }
      },
    },
    methods: {
      getBusinesses(search = '') {
        const query = {
          per_page: -1,
          search,
        };

        this.isLoadingBusinesses = true;

        return this.$store
          .dispatch('businesses/getItems', query)
          .then((res) => {
            this.isLoadingBusinesses = false;
            return res;
          })
          .catch((err) => {
            this.isLoadingBusinesses = false;
            return err;
          });
      },
      searchNetworks(search = '') {
        const query = {
          search,
        };

        this.isLoadingNetworks = true;

        return this.$store
          .dispatch('networks/searchItems', query)
          .then((res) => {
            this.networks = res.data.data;
            this.isLoadingNetworks = false;
            return res;
          })
          .catch((err) => {
            this.isLoadingNetworks = false;
            return err;
          });
      },
      onFilter() {
        const { business = {}, countries = [], network = {}, status = {} } = this;

        this.$emit('filter', {
          business: business?.id,
          countries,
          search: network?.name,
          status: status?.id,
        });
      },
      onClearFilters() {
        this.countries = [];
        this.networks = [];

        this.business = null;
        this.network = null;
        this.status = null;

        this.$refs.business.reset();
        this.$refs.network.reset();
        this.$refs.status.reset();

        this.$emit('clearFilters');
      },
    },
  };
</script>
